import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasicContainerComponent } from './basic-container.component';
import { IonicModule } from '@ionic/angular';
/**
 * @TODO circular dependency
 */
import { I18nModule } from '@foxeet/utils-modules';

@NgModule({
  declarations: [BasicContainerComponent],
  imports: [CommonModule, IonicModule, I18nModule.forChild()],
  exports: [BasicContainerComponent],
})
export class BasicContainerModule {}
